export const cookiesPolicy = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Cookie Policy',
  url: 'https://www.boldare.com/cookies-policy/',
  description:
    'Cookie Policy of Boldare. Explains which cookies and similar technologies boldare.com uses, for what purposes, which providers are involved, and how you can give, change, or withdraw consent.',
  publisher: {
    '@type': 'Organization',
    name: 'BOLDARE S.A.',
    url: 'https://www.boldare.com',
    legalName: 'BOLDARE S.A.',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Zwycięstwa 52',
      postalCode: '44-100',
      addressLocality: 'Gliwice',
      addressCountry: 'PL',
    },
    taxID: 'NIP: 6312698829',
    identifier: {
      '@type': 'PropertyValue',
      name: 'KRS',
      value: '0000914518',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'ado@boldare.com',
      contactType: 'Data Protection Officer',
    },
  },
};
